import React from 'react';
import { INFTCard } from '../../components/NFTCard/INFTCard'
import useGetNFTCollection from '../../data/useGetNFTCollection';
import NFTCollectionsList from '../../data/NFTCollectionsList'
import { INFTCardFormatted } from '../../components/NFTCard/INFTCard'
import DefaultCard from './DefaultCard';
import GeneralCard from './GeneralCard';
import AvaPepeCard from './AvaPepeCard';
import AvawareAllenCard from './AvawareAllenCard';
import AVAXBrosNFTCard from './AVAXBrosNFTCard';
import AvaxCatsCard from './AvaxCatsCard';
import AvaxcellsCard from './AvaxcellsCard';
import AvaxtarsCard from './AvaxtarsCard';
import ChillAFSlothsCard from './ChillAFSlothsCard';
import CryptoDappersCard from './CryptoDappersCard';
import CryptoSealCard from './CryptoSealCard';
import CryptoWaifusCard from './CryptoWaifusCard';
import DeproApeCryptoClubCard from './DeproApeCryptoClubCard';
import HatchyPocketCard from './HatchyPocketCard';
import HeroesOfNFTCard from './HeroesOfNFTCard';
import HuskyNFTCard from './HuskyNFTCard';
import LootFishCard from './LootFishCard';
import NeonMonstersCard from './NeonMonstersCard';
import NovaXCard from './NovaXCard';
import PudgyPenguinsCard from './PudgyPenguinsCard';
import SkiptNFTCard from './SkiptNFTCard';
import SnowBallCard from './SnowBallCard';
import SporeCard from './SporeCard';


interface INFTCardFormater extends INFTCard {
    detailUrl: string
}

const a = NFTCollectionsList;

const defaultCollection = {
    id: 'yetiswapCollection',
    tokenAddress: '0x0000000004bfef9b1a67aa4e15943824996c9761',
    name: '...',
    category: 0,
    creatorAddress: '',
    cardFormat: "DefaultCard",
    detailFormat: "DefaultDetail",
    activityFormat: "ActivityDetail"
}

const getNFTCard = (cardFormat: string, props: INFTCardFormatted) => {
    switch (cardFormat) {
        case "GeneralCard": {
            return <GeneralCard {...props} />
        }
        case "AvawareAllenCard": {
            return <AvawareAllenCard {...props} />
        }
        case "AvaPepeCard": {
            return <AvaPepeCard {...props} />
        }
        case "AVAXBrosNFTCard": {
            return <AVAXBrosNFTCard {...props} />
        }
        case "AvaxCatsCard": {
            return <AvaxCatsCard {...props} />
        }
        case "AvaxcellsCard": {
            return <AvaxcellsCard {...props} />
        }
        case "AvaxtarsCard": {
            return <AvaxtarsCard {...props} />
        }
        case "ChillAFSlothsCard": {
            return <ChillAFSlothsCard {...props} />
        }
        case "CryptoDappersCard": {
            return <CryptoDappersCard {...props} />
        }
        case "CryptoSealCard": {
            return <CryptoSealCard {...props} />
        }
        case "CryptoWaifusCard": {
            return <CryptoWaifusCard {...props} />
        }
        case "DeproApeCryptoClubCard": {
            return <DeproApeCryptoClubCard {...props} />
        }
        case "HatchyPocketCard": {
            return <HatchyPocketCard {...props} />
        }
        case "HeroesOfNFTCard": {
            return <HeroesOfNFTCard {...props} />
        }
        case "HuskyNFTCard": {
            return <HuskyNFTCard {...props} />
        }
        case "LootFishCard": {
            return <LootFishCard {...props} />
        }
        case "NeonMonstersCard": {
            return <NeonMonstersCard {...props} />
        }
        case "NovaXCard": {
            return <NovaXCard {...props} />
        }
        case "PudgyPenguinsCard": {
            return <PudgyPenguinsCard {...props} />
        }
        case "SkiptNFTCard": {
            return <SkiptNFTCard {...props} />
        }
        case "SporeCard": {
            return <SporeCard {...props} />
        }
        case "SnowBallCard": {
            return <SnowBallCard {...props} />
        }
        case "DefaultCard":
        default: {
            return <DefaultCard {...props} />
        }
    }
}

const NFTCardFormater = (props: INFTCardFormater) => {
    const { token, tokenContractAddress, detailUrl } = props
    const contractAddress = token ? token.tokenContract : tokenContractAddress

    const foundedCollection: any = useGetNFTCollection(contractAddress);

    return getNFTCard(foundedCollection ? foundedCollection.cardFormat : defaultCollection.cardFormat, {
        ...props,
        collection: foundedCollection ? foundedCollection : defaultCollection,
        detailUrl
    });
}

export default NFTCardFormater;